import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
interface Testimonial {
  initials: string;
  name: string;
  location: string;
  text: string;
}
interface TestimonialsProps {
  testimonials: Testimonial[];
}
export function Testimonials({
  testimonials
}: TestimonialsProps) {
  return <section className="py-8 px-4 pt-[10px] pb-[10px]" data-id="element-274">
      <div className="max-w-5xl mx-auto" data-id="element-275">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3" data-id="element-276">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-dark-card border border-dark-border rounded-xl p-3 flex flex-col" data-id="element-277">
              <div className="flex items-center space-x-2 mb-2" data-id="element-278">
                <div className="w-8 h-8 rounded-full bg-brand/20 text-brand flex items-center justify-center font-bold text-sm" data-id="element-279">
                  {t.initials}
                </div>
                <div data-id="element-280">
                  <div className="font-bold text-white text-xs" data-id="element-281">{t.name}</div>
                  <div className="text-[10px] text-gray-500" data-id="element-282">{t.location}</div>
                </div>
              </div>
              <div className="flex space-x-0.5 mb-2" data-id="element-283">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-2.5 h-2.5 fill-brand text-brand" data-id="element-284" />)}
              </div>
              <p className="text-gray-300 italic flex-grow text-xs leading-relaxed" data-id="element-285">
                "{t.text}"
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}